import { FormLabel } from "components/form";
import { Label } from "ui/components/label";

export default function FilterWrapper({
  label,
  children,
  className,
  required,
}) {
  if (!label) {
    return <div className={className}>{children}</div>;
  }

  if (required) {
    return (
      <div className={className}>
        <FormLabel required={required} className="mb-2 text-sm">
          {label}
        </FormLabel>
        {children}
      </div>
    );
  }

  return (
    <div className={className}>
      {" "}
      <Label className="mb-2 text-sm">{label}</Label> {children}
    </div>
  );
}
